module.exports = __webpack_public_path__ + "static/img/2.9f21808.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/eng/2.png
// module id = OPlF
// module chunks = 0